import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '吃得文明公益主题征文大赛';

const route: RouteConfig = {
  path: '/20200317CDWM',
  name: 'CDWM',
  component: () => import('./Home.vue'),
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'Contribute',
      component: () => import('./Contribute.vue'),
      name: 'Contribute',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'SearchSchoolList',
      component: () => import('./SearchSchoolList.vue'),
      name: 'SearchSchoolList',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'First',
      component: () => import('./First.vue'),
      name: 'CDWMFirst',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: 'CDWMDetail',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: 'ListPage',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'SearchPage',
      component: () => import('./SearchPage.vue'),
      name: 'SearchPage',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'User',
      component: () => import('./User.vue'),
      name: 'CDWMUser',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
